import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export type DataSourceMode = 'demo' | 'live';

interface DataSourceContextType {
  mode: DataSourceMode;
  setMode: (mode: DataSourceMode) => void;
  isDemoMode: boolean;
}

const DataSourceContext = createContext<DataSourceContextType | undefined>(undefined);

interface DataSourceProviderProps {
  children: ReactNode;
}

export const DataSourceProvider: React.FC<DataSourceProviderProps> = ({ children }) => {
  const [mode, setModeState] = useState<DataSourceMode>(() => {
    const saved = localStorage.getItem('adminDataSource');
    return saved === 'demo' ? 'demo' : 'live';
  });

  const setMode = (newMode: DataSourceMode) => {
    console.log('🔄 DataSourceContext: Changing mode from', mode, 'to', newMode);
    setModeState(newMode);
    localStorage.setItem('adminDataSource', newMode);

    // Dispatch custom event for components to listen to
    console.log('📢 DataSourceContext: Dispatching dataSourceChanged event');
    window.dispatchEvent(new CustomEvent('dataSourceChanged', { detail: { mode: newMode } }));
  };

  const isDemoMode = mode === 'demo';

  return (
    <DataSourceContext.Provider value={{ mode, setMode, isDemoMode }}>
      {children}
    </DataSourceContext.Provider>
  );
};

export const useDataSource = (): DataSourceContextType => {
  const context = useContext(DataSourceContext);
  if (context === undefined) {
    throw new Error('useDataSource must be used within a DataSourceProvider');
  }
  return context;
};

